<template>
  <header v-show="!isCurrentChatFullScreen" class="messages__header">
    <h1>{{ i18n.$gettext('Messages') }}</h1>
    <ChatScopeSwitcher v-if="isReady" />
  </header>
  <router-view v-if="isReady" v-bind="nestedViewProps" :aria-label="inboxLabel" />
  <div v-else class="messages__loader_wrapper">
    <Loader class="messages__loader" :loading="!isReady" />
  </div>
  <Notifications />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChatScopeSwitcher from './ChatScopeSwitcher.vue'
import Notifications from './Notifications.vue'
import Loader from './Loader.vue'
import { tabletMinWidth } from '../../../../css/redesign/exports/misc.scss'
export default {
  name: 'DirectMessages',
  components: { Loader, ChatScopeSwitcher, Notifications },
  props: {
    helpCenterURL: { type: String, required: true },
    discoverPath: { type: String, required: true },
    defaultChatScope: { type: String, required: true }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      nestedViewProps: {
        helpCenterURL: this.helpCenterURL,
        discoverPath: this.discoverPath
      }
    }
  },
  computed: {
    ...mapGetters({
      isInitialDataLoaded: 'isInitialDataLoaded'
    }),
    currentChatScope() {
      return this.$store.getters.getChatScopeByPath(this.$route.params.chatScope)
    },
    isReady() {
      return this.isInitialDataLoaded && !!this.currentChatScope
    },
    isCurrentChatFullScreen() {
      return !!this.$route.params.chat && this.windowWidth < parseInt(tabletMinWidth)
    },
    inboxLabel() {
      return this.i18n.$gettext('Inbox')
    }
  },
  async created() {
    if (!this.$route.params.chatScope) {
      await this.$router.replace({ path: '/' + this.defaultChatScope })
    }
    await this.fetchChats()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions(['fetchChats']),
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
